module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_top_promo_numbers-3b2dd1a5e716b5aabf3e89fdf270e2bc.png";